import React, { Component } from 'react';
import PropTypes from 'prop-types';
import transition from 'styled-transition-group';
import styled from 'styled-components';
import { position } from 'polished';
import _ from 'lodash';
import { getLayer, color } from '@deerplusofficial/pos-helper';
import { ButtonBase, Button, Icon } from '@deerplusofficial/pos-components';

const DURATION = 400;

export const Container = transition.div.attrs({
  timeout: DURATION,
  mountOnEnter: true,
  unmountOnExit: true,
})`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 28px 10px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity ${DURATION / 1000}s ease-in;
  z-index: ${getLayer('modal')};
  ${position('fixed', '0', null, null, '0')};
  &:enter,
  &:exit-active {
    opacity: 0.01;
  }
  &:enter-active {
    opacity: 1;
  }
`;

const Content = transition.div.attrs({
  timeout: DURATION,
})`
  padding: 0 24px 24px;
  width: 100%;
  max-width: 380px;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  &:appear,
  &:exit-active {
    transform: translate(0, -40px);
  }
  &:exit-active,
  &:appear-active {
    transition: transform 0.3s ease-in-out;
  }
  &:appear-active {
    transform: translate(0, 0);
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  color: ${color.text.title};
  font-size: 16px;
`;

const CloseButton = styled(ButtonBase)`
  margin-left: auto;
  padding: 20px 24px;
  ${position('relative', null, '-24px', null, null)};
`;

const CloseIcon = styled(Icon).attrs({ icon: 'times' })`
  color: ${color.text.secondary};
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const RemoveButton = styled(Button).attrs({ cancel: true })`
  flex: 1;
  margin-right: 8px;
`;

const OptionButton = styled(Button).attrs({ secondary: true })`
  flex: 2;
  margin-right: 16px;
`;

const SaveButton = styled(Button).attrs({ primary: true })`
  flex: 2;
`;

export default class Modal extends Component {
  static propTypes = {
    active: PropTypes.bool,
    actions: PropTypes.shape({
      cancel: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        disabled: PropTypes.bool,
      }),
      option: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        disabled: PropTypes.bool,
        loading: PropTypes.bool,
      }),
      save: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        disabled: PropTypes.bool,
        loading: PropTypes.bool,
      }),
    }),
    title: PropTypes.string,
    onToggleModal: PropTypes.func,
  };

  static defaultProps = {
    active: false,
    actions: {},
    title: '',
    onToggleModal: _.identity,
  };

  render() {
    const {
      active,
      title,
      onToggleModal,
      children,
      className,
      actions: { remove, save, option },
    } = this.props;

    return (
      <Container in={active}>
        <Content appear in={active} className={className}>
          <Header>
            {title}
            <CloseButton onClick={onToggleModal}>
              <CloseIcon />
            </CloseButton>
          </Header>
          {children}
          <Actions>
            {remove && (
              <RemoveButton
                onClick={remove.callback}
                disabled={remove.disabled}
              >
                {remove.text}
              </RemoveButton>
            )}
            {option && (
              <OptionButton
                onClick={option.callback}
                disabled={option.disabled}
                loading={option.loading}
              >
                {option.text}
              </OptionButton>
            )}
            {save && (
              <SaveButton
                onClick={save.callback}
                disabled={save.disabled}
                loading={save.loading}
              >
                {save.text}
              </SaveButton>
            )}
          </Actions>
        </Content>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js